// extracted by mini-css-extract-plugin
export default {"ModalImages":"ModalImages_ModalImages__eeBx6","content":"ModalImages_content__zdbVI"};